var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10362",
    "data-name": "Group 10362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.571,
    height: 26.862,
    viewBox: "0 0 23.571 26.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4079",
    "data-name": "Rectangle 4079",
    width: 23.571,
    height: 26.862,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10361",
    "data-name": "Group 10361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44421",
    "data-name": "Path 44421",
    d: "M16.784,0a6.792,6.792,0,0,0,4.5,6.338,6.507,6.507,0,0,0,2.282.39V11.1A11.161,11.161,0,0,1,16.791,8.8c0,.142,0,.24,0,.339.011,3.1.027,6.19.033,9.286A8.419,8.419,0,0,1,.168,20.182a8.325,8.325,0,0,1,5.814-9.59,8.791,8.791,0,0,1,3.447-.3c.077.009.153.031.243.049v4.388A11.979,11.979,0,0,0,8.4,14.592a3.954,3.954,0,1,0,3.979,4.027c.032-2.29.015-4.581.016-6.872q0-5.705,0-11.411c0-.112.02-.224.031-.336Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.a42b921f64ec5419dfc6724c2b3ad5ae.svg";
export { ForwardRef as ReactComponent };